export const PXPostFeed = (function () {
	'use strict';

	let $customSelect;

	function init() {


		$customSelect = $('select[name="content-type"]');

		events();


		const feed = document.querySelector('.pxblock--post-feed .col-container');
		if(feed){
			var masonry = new Masonry(`.pxblock--post-feed .col-container`, {
				// gutter: 20,
				// options
			});
		}
	}

	function events() {

		// $(window).on('load', function() {
		// 	$('.postblock__title').collapser({
		// 		mode: 'lines',
		// 		truncate: 3,
		// 		showText: '',
		// 		ellipsis: '...'
		// 	});
		// });

		/*
			If filtered - scroll to section
		*/
		const pathMatch = window.location.pathname + window.location.search;
		let $elem = $('a[href="' + pathMatch + '"]');
		// console.log(window.location.search)

		if (!$elem.length) {
			$elem = $('option[value="' + pathMatch + '"]');
		}

		if ($elem.length) {
			const $block = $elem.parents('.pxblock');

			if ($block.length) {
				$('html,body').animate({
					scrollTop: $block.offset().top
				}, 500);
			}
		}

		$customSelect.on('change', function (e) {
			e.preventDefault();
			window.location = $(this).val();
		});

	}

	return {
		init: init,
	};
})();
